import React, { useEffect } from "react";
import {
  Box,
  Grid,  
  Button, 
  Typography,
  Divider
 
} from "@mui/material";

import { StoredCardDetailProps } from "./paymentType";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { updateReservation } from "components/store/actions/reservation/reservationActions";
import { useTranslation } from "react-i18next";
import { AppState } from "components/store/reducers/rootReducer";
import { getCardBrand, getCardExpiry, getMaskedCardNumber,isCreditCardExpired,isCreditCardExpiryValid } from "../../../../helpers/creditCard";

import useReservationMode, { ReservationMode } from "helpers/useReservationMode";
import _ from "lodash";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
const StoredCardPayment: React.FC<StoredCardDetailProps> = (props) => {
 
  const { t } = useTranslation();
  let { reservation } = useSelector((state: AppState) => state.dailyRental);
  const [errorMessage, setErrorMessage] = React.useState("");
    const theme = useTheme();
    const IsDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const [resMode] = useReservationMode();
  const dispatch = useDispatch();
  const ValidateRentalPeriod = (data) =>
    {          
      if(isCreditCardExpired (data.data.cardDetails.expiration.lastValidMonth.toString(), data.data.cardDetails.expiration.year.toString()))
      {
        setErrorMessage(props.isBobo ? t("ReservationWizard.paymentPage.msgCardExpiredForBobo") : t("ReservationWizard.paymentPage.msgCardExpired"));
          props.canContinue(false);
          return;
      }

      if(!isCreditCardExpiryValid(data.data.cardDetails.expiration.lastValidMonth.toString(), data.data.cardDetails.expiration.year.toString(), reservation?.dateTime?.endDateTime.toString()))
        {        
          setErrorMessage(t(resMode === ReservationMode.Edit ? "ReservationWizard.paymentPage.msgCardExpiryBeforeEndDateForEdit" : (props.isBobo ? "ReservationWizard.paymentPage.msgStoredCardExpiryBeforeEndDateForBobo": "ReservationWizard.paymentPage.msgStoredCardExpiryBeforeEndDate")));
          props.canContinue(false);         
        }
        else
        {       
          props.canContinue(true);
          let newReservation = _.cloneDeep(reservation);
          newReservation?.additionalInformation?.additionalInformationFields?.forEach((item:any) => {
            if(item.fieldName.toLowerCase() === "etd_res_id") {
              item.fieldValue = data.contextId;
              }           
          });
  
          if(newReservation) 
           { newReservation.payment = { activityUrn: data.contextId, contextId: data.contextId,
                                        cardExpiry : getCardExpiry(data?.data.cardDetails.expiration.lastValidMonth.toString(), data?.data.cardDetails.expiration.year.toString()),
                                        cardBrand : getCardBrand(data?.data.cardAttributes.cardBrand.toString()),
                                        cardNumber : getMaskedCardNumber(data?.data.cardDetails.maskedCardNumber),                                        
                                        walletInstrument: data.data.urn};
            newReservation.isStoredCard = true;
           }
  
          console.log("Updated Reservation: ", newReservation);
          if(newReservation) {
            dispatch(updateReservation({
              reservation: newReservation,
              hasError: false,
              errors: [],
            }));
          }
          setErrorMessage("");
        }
      }

  useEffect(() => {   
      if(props.data?.hasStoredCard)
       {       
        ValidateRentalPeriod(props.data);
       }
        
    }, [props.data]);
  return (
   
      <Box
      boxShadow={3}
      p={3}
      bgcolor="background.paper"  
      style={{ textAlign:"center",  marginTop:"20px", width: (IsDesktop ? "40%" : "100%"), verticalAlign:"middle", justifyContent:"center"}}     
    >
      {(errorMessage.length > 0) && 
      <Typography id="lblErrorMessage"  data-testid="lblErrorMessage"   variant="body2" style={{textAlign:"left", color:"#DF0000",  marginBottom:"10px"}} > {errorMessage} </Typography> 
  }
      
      <Grid container >
        <div>
          {reservation?.isBOBOBooking && reservation?.driverViewModelForBOBO?.firstName && reservation?.driverViewModelForBOBO?.lastName ?(
            <Typography
            id = "paymentPageMethod"
            variant="h2"
            style={{
              marginTop: 0,
              marginBottom: "15px",
            }}
          >
           {t(
                  "ReservationWizard.paymentPage.labelSectionPaymentMethod"
                )} ({reservation?.driverViewModelForBOBO?.firstName} {reservation?.driverViewModelForBOBO?.lastName})
          </Typography>):
          (
            <Typography
            id = "paymentPageMethod"
            variant="h2"
            style={{
              marginTop: 0,
              marginBottom: "15px",
            }}
          >
           {t(
                  "ReservationWizard.paymentPage.labelSectionPaymentMethod"
                )}
          </Typography>)
          
          }
          
        </div>
        <Grid container spacing={1} >
          <Grid item xs={12}>      
          <Divider style={{ backgroundColor: "black", fontWeight: "normal" }} />
          </Grid>
      
          <Grid item xs={12} md={5}  style={{ textAlign:"left"}} ><span id="lblCardNumber">{getMaskedCardNumber(props.data?.data.cardDetails.maskedCardNumber)}</span>     </Grid>
          <Grid item xs={12} md={4}> <span id="lblCardExpiry">{getCardExpiry(props.data?.data.cardDetails.expiration.lastValidMonth.toString(), props.data?.data.cardDetails.expiration.year.toString())}</span> </Grid>     
          <Grid item xs={12} md={3}> <span id="lblCardBrand">{getCardBrand(props.data?.data.cardAttributes.cardBrand.toString())}</span>     </Grid>
          
        </Grid>
      
            
      <Grid item xs={12} style={{textAlign:"left", marginTop:"15px"}}>  <Button
          id="btnEditCard"        
          data-testid="btnEditCard"  
          color="primary"
          variant="contained"
          aria-label={t("lblContinueToNextStep")}
          type="button"
          onClick={() => {
           props.updateStoredCardFlag(false)
          }}
        >
         {t("btnOneTimePayment")}
        </Button> 
          </Grid>
      
          </Grid>

      </Box>
   
);
};
export default StoredCardPayment;

